import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";

import { API_ENDPOINT } from "../../config";
import { Chapter, ListResponse } from "../../interfaces";
import { toastMessage } from "../../utils/toastError";

export const chapterApi = createApi({
  reducerPath: "chapterApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_ENDPOINT + "/chapter",
    credentials: "include",
  }),
  endpoints: (build) => ({
    getChapters: build.query<ListResponse<Chapter>, { subject_id: number | string }>({
      query: (params) => ({
        url: "/",
        method: "GET",
        params,
      }),
    }),
    createChapter: build.mutation<Chapter, { name: string; subject_id: number | string }>({
      query: (payload) => ({
        url: "/",
        method: "POST",
        body: payload,
      }),
      transformErrorResponse(baseQueryReturnValue) {
        toastMessage("error", baseQueryReturnValue.data);
        return Promise.reject(baseQueryReturnValue.data);
      },
      transformResponse(baseQueryReturnValue: Chapter) {
        toastMessage("success", "Successfully created");
        return baseQueryReturnValue;
      },
    }),
    updateChapter: build.mutation<Chapter, { id: string; name: string }>({
      query: (payload) => ({
        url: "/",
        method: "PUT",
        body: payload,
      }),
      transformErrorResponse(baseQueryReturnValue) {
        toastMessage("error", baseQueryReturnValue.data);
        return Promise.reject(baseQueryReturnValue.data);
      },
      transformResponse(baseQueryReturnValue: Chapter) {
        toastMessage("success", "Successfully updated");
        return baseQueryReturnValue;
      },
    }),
    deleteChapter: build.mutation<any, string | number>({
      query: (id) => ({
        url: "/",
        method: "DELETE",
        body: { id },
      }),
      transformErrorResponse(baseQueryReturnValue) {
        toastMessage("error", baseQueryReturnValue.data);
        return Promise.reject(baseQueryReturnValue.data);
      },
      transformResponse(baseQueryReturnValue) {
        toastMessage("success", "Successfully deleted");
        return baseQueryReturnValue;
      },
    }),
  }),
});

export const {
  // Chapters
  useCreateChapterMutation,
  useUpdateChapterMutation,
  useDeleteChapterMutation,
  useLazyGetChaptersQuery,
  // Tags
} = chapterApi;
